
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gfwv3_lapq4_193",
  "horizontal": "awsui_horizontal_gfwv3_lapq4_196",
  "vertical": "awsui_vertical_gfwv3_lapq4_202",
  "list": "awsui_list_gfwv3_lapq4_207",
  "grid": "awsui_grid_gfwv3_lapq4_226",
  "list-item": "awsui_list-item_gfwv3_lapq4_238",
  "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_lapq4_245",
  "toggle": "awsui_toggle_gfwv3_lapq4_245",
  "description": "awsui_description_gfwv3_lapq4_337",
  "separator": "awsui_separator_gfwv3_lapq4_341"
};
  